import React from "react";
import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";

/**
 * Dialog for creating or editing a booking/note on the calendar.
 */
const BookingFormDialog = ({
  open,
  onOpenChange,
  selectedDate,
  editingBooking,
  bookingForm,
  setBookingForm,
  onSave
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{editingBooking ? "Editar Marcação" : "Nova Marcação"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div>
            <label className="text-sm font-medium text-[#475569] block mb-1">Data</label>
            <p className="text-sm text-[#0F172A]">
              {selectedDate && format(parseISO(selectedDate), "EEEE, d MMMM yyyy", { locale: pt })}
            </p>
          </div>
          <div>
            <label className="text-sm font-medium text-[#475569] block mb-1">Horário (opcional)</label>
            <Input
              placeholder="Ex: 10:00-12:00 ou Manhã"
              value={bookingForm.time_slot}
              onChange={(e) => setBookingForm({ ...bookingForm, time_slot: e.target.value })}
              data-testid="booking-time-slot"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-[#475569] block mb-1">Notas</label>
            <Textarea
              placeholder="Ex: 3 alunos marcados para surf de manhã..."
              value={bookingForm.notes}
              onChange={(e) => setBookingForm({ ...bookingForm, notes: e.target.value })}
              rows={3}
              data-testid="booking-notes"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={onSave} className="bg-[#6697a4] hover:bg-[#567f8a]" data-testid="save-booking-btn">
            {editingBooking ? "Guardar" : "Criar Marcação"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BookingFormDialog;
